import { EventEmitter, InjectorService } from '@tencent/workbench';


export const loadTask = (load) => {
    InjectorService.get(EventEmitter).listenOnce('loadDynamicLoaders', () => {
        load().then(() => {
            console.log('dynamic loaders which registered are loaded');
        });
    });
};
